import { WordCloudComponent } from '../charts/word-cloud-component'

export class AFPositiveWordCloud extends WordCloudComponent {
 static config = {
  selector: 'afPositiveWordCloud',
  controller: AFPositiveWordCloud,
  bindings: WordCloudComponent.config.bindings,
  template: WordCloudComponent.config.template,
 }

 setProperties() {
  this.seriesColors = '#87BF1A'
 }

 onPointClick = event => {
  this.triggerUpdate(
   this.updatePayload(
    'FILTER_CHANGE',
    'append',
    'subKeyword',
    this.getOriginalTerm(event.key, this.vizData.data.all)
   )
  )
  this.triggerUpdate(this.updatePayload('FILTER_CHANGE', 'append', 'sentiment', 'p'))
 }
}
